"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  ConfigProvider: true,
  useConfig: true
};
exports.useConfig = exports.ConfigProvider = void 0;

var _merge = _interopRequireDefault(require("lodash/merge"));

var _react = _interopRequireWildcard(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = require("styled-components");

var _stylisPluginExtraScope = _interopRequireDefault(require("stylis-plugin-extra-scope"));

var _NotificationsProvider = _interopRequireDefault(require("../NotificationsProvider"));

var _constants = require("./constants");

Object.keys(_constants).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _constants[key];
    }
  });
});

var _context = require("./utils/context");

Object.keys(_context).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _context[key];
    }
  });
});

var _theme = _interopRequireWildcard(require("./utils/theme"));

Object.keys(_theme).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _theme[key];
    }
  });
});

var _translations = _interopRequireWildcard(require("./utils/translations"));

Object.keys(_translations).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _translations[key];
    }
  });
});

var _portalsRoot = require("./utils/portalsRoot");

var _normalizer = _interopRequireDefault(require("./utils/normalizer"));

var _schema = _interopRequireDefault(require("./schema"));

var _linkRenderer = require("./utils/linkRenderer");

Object.keys(_linkRenderer).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _linkRenderer[key];
    }
  });
});

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    keys.push.apply(keys, Object.getOwnPropertySymbols(object));
  }

  if (enumerableOnly) keys = keys.filter(function (sym) {
    return Object.getOwnPropertyDescriptor(object, sym).enumerable;
  });
  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var ConfigProvider = function ConfigProvider(props) {
  var children = props.children,
      extraScope = props.extraScope,
      _props$portalsRoot = props.portalsRoot,
      portalsRoot = _props$portalsRoot === void 0 ? _constants.PORTALS_ROOT_SELECTOR : _props$portalsRoot,
      theme = props.theme,
      translations = props.translations,
      rest = _objectWithoutProperties(props, ["children", "extraScope", "portalsRoot", "theme", "translations"]); // we need to create the portal root the first time we are rendered
  // with portalsRoot === PORTALS_ROOT_SELECTOR


  var defaultPortalRootRef = (0, _react.useRef)(false);
  var defaultPortalRootCreated = defaultPortalRootRef.current;

  if (portalsRoot === _constants.PORTALS_ROOT_SELECTOR && !defaultPortalRootRef.current) {
    (0, _portalsRoot.createPortalsRoot)();
    defaultPortalRootCreated = true;
  } // set the ref once the default portal root has been created, so we
  // don't do it again


  (0, _react.useEffect)(function () {
    defaultPortalRootRef.current = defaultPortalRootCreated;
  }, [defaultPortalRootCreated]);
  var getPortalsRootElement = (0, _react.useCallback)((0, _portalsRoot.makePortalsRootGetter)(portalsRoot), [portalsRoot]);
  var createPortal = (0, _react.useCallback)(function (portalChildren) {
    var portalRootSelector = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
    var portalRoot = getPortalsRootElement(portalRootSelector);

    if (portalRoot) {
      return _reactDom.default.createPortal(_react.default.createElement(_normalizer.default, null, portalChildren), portalRoot);
    } // the only time the portalRoot will be null is if canUseDOM is false,
    // so this can be ignored.

    /* istanbul ignore next */


    return null;
  }, [getPortalsRootElement]);
  var value = (0, _react.useMemo)(function () {
    var finalTheme = (0, _merge.default)({}, _theme.default, theme);
    var finalTranslations = (0, _merge.default)({}, _translations.default, translations);
    return _objectSpread({}, _context.defaultConfig, {
      portalsRoot: portalsRoot,
      getPortalsRootElement: getPortalsRootElement,
      createPortal: createPortal,
      theme: finalTheme,
      translations: finalTranslations,
      extraScope: extraScope
    }, rest);
  }, [getPortalsRootElement, portalsRoot, createPortal, theme, translations, rest, extraScope]); // FIXME: when SCv5 types are updated, return StyleSheetManagerProps
  // eslint-disable-next-line @typescript-eslint/no-explicit-any

  var styleSheetManagerProps = (0, _react.useMemo)(function () {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var managerProps = {};

    if (extraScope) {
      var extraScopePlugin = (0, _stylisPluginExtraScope.default)(extraScope);
      Object.defineProperty(extraScopePlugin, 'name', {
        value: 'extraScopePlugin'
      });
      managerProps.stylisPlugins = [extraScopePlugin];
    }

    return managerProps;
  }, [extraScope]);
  return _react.default.createElement(_context.ConfigContext.Provider, {
    value: value
  }, _react.default.createElement(_styledComponents.StyleSheetManager, styleSheetManagerProps, _react.default.createElement(_styledComponents.ThemeProvider, {
    theme: value.theme
  }, _react.default.createElement(_normalizer.default, null, _react.default.createElement(_NotificationsProvider.default, null, children)))));
};

exports.ConfigProvider = ConfigProvider;
ConfigProvider.propTypes = _objectSpread({}, _schema.default.propTypes, {
  // eslint-disable-next-line react/require-default-props
  linkRenderer: _propTypes.default.elementType
});

var useConfig = function useConfig() {
  return _react.default.useContext(_context.ConfigContext);
};

exports.useConfig = useConfig;